import { computed, onMounted, watch } from "vue";
import { useUserStore } from "~/store/user/userStore";

/**
 * Nome do usuário logado para o cabeçalho desktop.
 * Só o nome (`DESCR_754`) — sem cargo.
 */
export function useUsuarioLogadoDisplay() {
	const userStore = useUserStore();

	const displayName = computed(() => {
		const nome = String(userStore.userName ?? "").trim();
		if (nome) return nome;
		const id = Number(userStore.userID);
		return id > 0 ? String(id) : "—";
	});

	async function carregarNome() {
		if (!import.meta.client) return;

		const id = Number(userStore.userID);
		const empresa = Number(userStore.companyID);
		if (!id || !empresa) return;
		if (String(userStore.userName ?? "").trim()) return;

		try {
			const { $r3fetchdata } = useNuxtApp();
			if (!$r3fetchdata?.get) return;

			const res: any = await $r3fetchdata.get(
				"/api/genericdatafinder/getsearchresult" as any,
				{
					params: {
						DataFinderName: "DF_E754",
						Params: [
							{ name: "EMPRESA", val: String(empresa) },
							{ name: "USUARIO", val: String(id) },
						],
						SearchValue: String(id),
						SearchField: "USU_PK_754",
						OrderField: "USU_PK_754",
						OrderBy: "ASC",
						SQLOverride: [
							"SELECT USUARIO_754.\"USU_PK_754\", USUARIO_754.\"DESCR_754\"",
							"  FROM \"USUARIO_754\" USUARIO_754",
							" WHERE USUARIO_754.\"USU_PK_754\" = :USUARIO",
							"   AND USUARIO_754.\"EMPRESA_FK_754\" = :EMPRESA",
							"   AND USUARIO_754.\"USU_PK_754\" <> '9999'",
						].join("\n"),
					},
				},
			);

			const body = res?.response ?? res;
			const lista = body?.result ?? body?.response?.result ?? [];
			const linha = Array.isArray(lista)
				? (lista.find((u: any) => Number(u?.USU_PK_754) === id) ?? lista[0])
				: null;
			const nome = String(linha?.DESCR_754 ?? "").trim();
			if (nome) userStore.setUserName(nome);
		}
		catch (e) {
			console.warn("[useUsuarioLogadoDisplay] falha ao carregar nome:", e);
		}
	}

	onMounted(() => {
		void carregarNome();
	});

	watch(
		() => [userStore.userID, userStore.companyID] as const,
		() => {
			void carregarNome();
		},
	);

	return { displayName, carregarNome };
}
